"use strict";
var PromiseObservable_1 = require('./PromiseObservable');
exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/observable/fromPromise.js
// module id = 157
// module chunks = 3